import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/wish',
  name: ROUTE_NAME.WISH_INDEX,
  meta: {
    title: '制作心愿单'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "wish" */
      '@/pages/wish/index.vue'),
      loading: Loading
    };
  }
}, {
  path: '/wish/add',
  name: ROUTE_NAME.WISH_ADD,
  meta: {
    title: '愿望池'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "wish" */
      '@/pages/wish/addWish.vue'),
      loading: Loading
    };
  }
}, {
  path: '/wish/selectBg',
  name: ROUTE_NAME.WISH_SELECTBG,
  meta: {
    title: '选背景'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "wish" */
      '@/pages/wish/selectBg.vue'),
      loading: Loading
    };
  }
}, {
  path: '/wish/success',
  name: ROUTE_NAME.WISH_SUCCESS,
  meta: {
    title: '生成成功'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "wish" */
      '@/pages/wish/success.vue'),
      loading: Loading
    };
  }
}];